import React from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  padding: 4rem 1.5rem;
  color: #1e293b;
  font-family: 'Inter', 'Segoe UI', sans-serif;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
`;

const SubTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
`;

const List = styled.ul`
  list-style: disc;
  padding-left: 1.25rem;
  margin-bottom: 1rem;
`;

const Link = styled.a`
  color: #2563eb;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default function PrivacyPolicy() {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      <Paragraph>Effective Date: April 2025</Paragraph>

      <Paragraph>
        LaceAI ("we", "our", or "us") respects your privacy. This Privacy Policy
        explains how we collect, use, and protect your information when you use
        our services.
      </Paragraph>

      <SubTitle>What We Collect</SubTitle>
      <List>
        <li>Text workout descriptions you input</li>
        <li>Device identifiers and metadata (if syncing to Garmin)</li>
        <li>Email address (if you join our waitlist or contact us)</li>
      </List>

      <SubTitle>How We Use It</SubTitle>
      <List>
        <li>Convert your input into structured Garmin-compatible workouts</li>
        <li>Sync workouts to your Garmin account (with your permission)</li>
        <li>Communicate with you about updates, features, and support</li>
      </List>

      <SubTitle>Data Sharing</SubTitle>
      <Paragraph>
        We do <strong>not</strong> sell or share your data with third parties. Workout
        and account information is used only for the purposes stated above.
      </Paragraph>

      <SubTitle>Storage & Security</SubTitle>
      <Paragraph>
        All data is stored securely. We use encryption and best practices to
        protect user data.
      </Paragraph>

      <SubTitle>Garmin API</SubTitle>
      <Paragraph>
        If you connect your Garmin account, we use the Garmin Training API to
        create workouts on your behalf. This access is granted by you and can be
        revoked at any time via your Garmin account settings.
      </Paragraph>

      <SubTitle>Your Rights</SubTitle>
      <Paragraph>
        You may request deletion of your data at any time by contacting us at
        <Link href="mailto:alex@laceai.run"> alex@laceai.run</Link>.
      </Paragraph>

      <SubTitle>Contact</SubTitle>
      <Paragraph>
        For questions or concerns, email
        <Link href="mailto:alex@laceai.run"> alex@laceai.run</Link>
      </Paragraph>
    </Container>
  );
}